import * as types from '../types.js';

/**
 * Modal — Controle de movimentações (#MT-D8E2535).
 * Formatos: Tela (JSON), PDF, CSV, Excel (XLSX).
 */
export default {

	html: `
		<style>
			#movement-control-form #company_id  { width: 15rem; }
			#movement-control-form #warehouse_id { width: 15rem; }
			#movement-control-form #date_from,
			#movement-control-form #date_to     { width: 10rem; }
			#movement-control-form .mc-legend   { font-size: 0.85rem; color: var(--color-muted); line-height: 1.45; }
			#movement-control-form .mc-types label { display: inline-flex; align-items: center; gap: 0.35rem; margin-right: 1rem; cursor: pointer; }
		</style>
		<form id="movement-control-form" class="form" autocomplete="off">
			<datalist id="mc-companies"></datalist>
			<datalist id="mc-warehouses"></datalist>
			<div class="title">Controle de movimentações</div>
			<p class="mts mc-legend">
				<strong>Por posição:</strong> endereços que tiveram movimentação (acuracidade).<br>
				<strong>Origem × Destino:</strong> de onde saiu e para onde foi (ex.: <code>1-P-4-3</code> → <code>1-H-41-1</code>).
			</p>
			<div class="mtm mc-legend">
				<strong>Legenda dos tipos</strong><br>
				<strong>L→L</strong> — Transferência entre posições (derrubada / reendereçamento)<br>
				<strong>L→R</strong> — Reserva para picking (posição → reserva da saída)<br>
				<strong>R→O</strong> — Baixa de saída (reserva → saída / separação)
			</div>
			<div class="mtm">
				<label>Empresa<sup>*</sup>
					<input id="company_id" type="text" list="mc-companies" required>
				</label>
			</div>
			<div class="mtm" style="display:flex;gap:1rem;flex-wrap:wrap">
				<label>De<sup>*</sup>
					<input id="date_from" type="date" required>
				</label>
				<label>Até<sup>*</sup>
					<input id="date_to" type="date" required>
				</label>
			</div>
			<div class="mtm">
				<label>Armazém (opcional)
					<input id="warehouse_id" type="text" list="mc-warehouses">
				</label>
			</div>
			<div class="mtm">
				<label>Visão
					<select id="view">
						<option value="positions">Por posição</option>
						<option value="moves" selected>Origem × Destino</option>
					</select>
				</label>
			</div>
			<div class="mtm mc-types">
				<span style="display:block;margin-bottom:0.35rem">Tipos de movimento</span>
				<label><input type="checkbox" id="type_ll" checked> L→L</label>
				<label><input type="checkbox" id="type_lr" checked> L→R</label>
				<label><input type="checkbox" id="type_ro" checked> R→O</label>
			</div>
			<div class="mtm">
				<label>Formato
					<select id="format">
						<option value="json">Tela</option>
						<option value="pdf">PDF</option>
						<option value="csv">CSV</option>
						<option value="xlsx">Excel (XLSX)</option>
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class="bn_Escape button">Fechar</button>
					<button type="button" class="bn_Enter button">Gerar</button>
				</span>
			</div>
		</form>
	`,

		form: {
		selector: '#movement-control-form',
		init(formset) {
			formset.form.eraseValues();
			formset.loadList('#mc-companies', 'companies', { labels: ['nick'] });
			formset.loadList('#mc-warehouses', 'warehouses', { labels: ['name'] });
			const today = new Date();
			const iso = today.toISOString().slice(0, 10);
			const elFrom = formset.form.node.querySelector('#date_from');
			const elTo = formset.form.node.querySelector('#date_to');
			if (elFrom && !elFrom.value) elFrom.value = iso;
			if (elTo && !elTo.value) elTo.value = iso;
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#date_from' }, types: [types.pubsub()] },
		{ properties: { selector: '#date_to' }, types: [types.pubsub()] },
		{ properties: { selector: '#warehouse_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('warehouses')] },
		{ properties: { selector: '#view' }, types: [types.pubsub()] },
		{ properties: { selector: '#format' }, types: [types.pubsub()] },
	],

};
